import React from 'react'
import { connect } from 'react-redux'
import { Container, Card, OutlinedButton, FilledButton } from '@jsluna/react'
import { withRouter } from 'react-router-dom'
import { PropTypes } from 'prop-types'
import FormFieldValidation from 'components/FormFieldValidation'
import Dropdown from 'components/Dropdown'
import Breadcrumbs from 'components/Breadcrumbs'
import api from '../../../utils/api'
import { toTitleCase } from '../../../utils/common'
import DeleteModal from './../DeleteModal'
import Constants from './../../../utils/constants'

class ContractorForm extends React.Component {
  constructor(props) {
    super(props)
    this.handleTextChange = this.handleTextChange.bind(this)
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    this.handleDropdownBoxChange = this.handleDropdownBoxChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
    this.handleDeleteClick = this.handleDeleteClick.bind(this)
    this.handleDeleteModalReasonChange = this.handleDeleteModalReasonChange.bind(this)
    this.handleDeleteModalCancel = this.handleDeleteModalCancel.bind(this)
    this.handleDeleteModalConfirm = this.handleDeleteModalConfirm.bind(this)
    this.handleDeleteModalDoneClick = this.handleDeleteModalDoneClick.bind(this)
    this.setModalText = this.setModalText.bind(this)

    this.getHeader = this.getHeader.bind(this)
    this.state = {
      id: this.props.contractor.id,
      forename: this.props.contractor.forename || '',
      surname: this.props.contractor.surname || '',
      email: this.props.contractor.email || '',
      telephoneNumber: this.props.contractor.telephoneNumber || '',
      uniqueId: this.props.contractor.uniqueId || '',
      carRegistration: this.props.contractor.carRegistration || '',
      employerId: this.props.contractor.employerId,
      jobRoleId: this.props.contractor.jobRoleId,
      active: this.props.contractor.active,
      errors: null,
      isNew: this.props.contractor.id === 0,
      isDeleteModalOpen: false,
      options: {
        deletionReasonTypeId: Constants.DeletionReasonTypes.None,
        isPreAction: true,
        inProgress: false
      },
      hasDeletionErrored: false,
      isBiometricDeletion: false,
      deleteModalText: '',
      deleteReasonText: '',
      doneConfirmationText: '',
      doneInformationText: '',
      dropDownItems: []
    }
  }

  componentDidMount() {
    this.getDropDownData()
  }

  getDropDownData = () => {
    api.getJobRoles()
      .then((data) => {
        this.setState({ dropDownItems: data })
      })
  }

  getHeader() {
    return (<div className="ln-o-grid">
      <div className="ln-o-grid__item ln-u-1/2@sm">
        <h3>{this.props.contractor.forename} {this.props.contractor.surname}</h3>
      </div>
      <div className="ln-o-grid__item ln-u-1/2@sm u-right-align-sm">
        <a href="" onClick={e => this.handleDeleteClick(e, false)}><h6>Remove user</h6></a>
      </div>
    </div>)
  }

  setModalText(isBiometric) {
    if (isBiometric) {
      this.setState({ deleteModalText: `Are you sure you want to delete ${this.state.forename} ${this.state.surname}'s biometrics?`,
        deleteReasonText: `Reason for deleting ${this.state.forename}'s biometric information`,
        doneConfirmationText: `${this.state.forename} ${this.state.surname}'s biometric information has been deleted`,
        doneInformationText: 'You are required to inform the user their biometric information has been deleted.'
      })
    } else {
      this.setState({ deleteModalText: `Are you sure you want to remove ${this.state.forename} ${this.state.surname}?`,
        deleteReasonText: `Reason for removing ${this.state.forename}`,
        doneConfirmationText: `${this.state.forename} ${this.state.surname} has been removed`,
        doneInformationText: this.props.contractor.canDeleteBiometric ? 'You are required to inform the user their biometric information has been deleted.' : ''
      })
    }
  }

  handleTextChange(e, key, doTrim, doCapitalize, doTitleCase, callback) {
    const state = {}
    let value = e.target.value

    if (doTrim) {
      value = value.trim()
    }

    if (doCapitalize) {
      value = value.toUpperCase()
    }

    if (doTitleCase) {
      value = toTitleCase(value)
    }

    state[key] = value

    this.setState(state)
    this.props.setDirty()

    if (callback) {
      callback()
    }
  }

  handleCheckboxChange(e, key) {
    const state = {}

    state[key] = e.target.checked

    this.setState(state)
    this.props.setDirty()
  }

  handleDropdownBoxChange(e, key, callback) {
    const state = {}

    state[key] = e.target.value ? parseInt(e.target.value, 0) : 0

    this.setState(state)
    this.props.setDirty()

    if (callback) {
      callback()
    }
  }

  handleSubmit(e) {
    e.preventDefault()

    this.state.forename = this.state.forename.trim()
    this.state.surname = this.state.surname.trim()
    this.state.telephoneNumber = this.state.telephoneNumber.trim()
    this.state.uniqueId = this.state.uniqueId.trim()
    this.state.carRegistration = this.state.carRegistration.trim()

    this.props.contractor.forename = this.state.forename
    this.props.contractor.surname = this.state.surname
    this.props.contractor.telephoneNumber = this.state.telephoneNumber
    this.props.contractor.uniqueId = this.state.uniqueId
    this.props.contractor.carRegistration = this.state.carRegistration
    this.props.contractor.employerId = this.state.employerId
    this.props.contractor.jobRoleId = this.state.jobRoleId
    this.props.contractor.active = this.state.active
    this.props.submit()
  }

  handleCancel(e) {
    e.preventDefault()
    this.props.cancel()
  }

  handleDeleteClick(e, isBiometric) {
    e.preventDefault()
    this.setState({ isBiometricDeletion: isBiometric })
    this.setModalText(isBiometric)
    this.setState({ isDeleteModalOpen: true })
  }

  handleDeleteModalReasonChange(e, deletionReasonTypeId) {
    this.setState({ options: { deletionReasonTypeId, isPreAction: true, inProgress: false } })
  }

  handleDeleteModalCancel(e) {
    e.preventDefault()
    this.setState({ options: { deletionReasonTypeId: Constants.DeletionReasonTypes.None, isPreAction: true, inProgress: false } })
    this.setState({ isDeleteModalOpen: false, hasDeletionErrored: false })
  }

  handleDeleteModalDoneClick(e) {
    this.handleDeleteModalCancel(e)
    if (!this.state.isBiometricDeletion) {
      this.handleCancel(e)
    }
  }

  handleDeleteModalConfirm(e) {
    e.preventDefault()
    const deletionEntity = {
      contractorId: this.props.contractor.id,
      employerId: this.props.contractor.employerId,
      deletionReasonTypeId: this.state.options.deletionReasonTypeId
    }
    this.setState({ options: { deletionReasonTypeId: Constants.DeletionReasonTypes.None, isPreAction: true, inProgress: true } })

    if (this.state.isBiometricDeletion) {
      api.deleteBiometrics(deletionEntity)
        .then(() => {
          this.setState({ options: { deletionReasonTypeId: Constants.DeletionReasonTypes.None, isPreAction: false, inProgress: false } })
          this.props.contractor.canDeleteBiometric = false
        })
        .catch(() => {
          this.setState({ hasDeletionErrored: true })
        })
    } else {
      api.deleteContractor(deletionEntity)
        .then(() => {
          this.setState({ options: { deletionReasonTypeId: Constants.DeletionReasonTypes.None, isPreAction: false, inProgress: false } })
        })
        .catch(() => {
          this.setState({ hasDeletionErrored: true })
        })
    }
  }

  clearErrors(fieldName) {
    if (this.props.errors[fieldName]) {
      delete this.props.errors[fieldName]
    }
  }

  isChanged() {
    return (this.state.forename !== this.props.contractor.forename ||
      this.state.surname !== this.props.contractor.surname ||
      this.state.jobRoleId !== this.props.contractor.jobRoleId ||
      (this.state.telephoneNumber || '') !== (this.props.contractor.telephoneNumber || '') ||
      (this.state.uniqueId || '') !== (this.props.contractor.uniqueId || '') ||
      (this.state.carRegistration || '') !== (this.props.contractor.carRegistration || '') ||
      this.state.active !== this.props.contractor.active)
  }

  render() {
    return (
      <div className="ln-c-main-content ln-o-main-content-width" id="main-content">
        <Container soft>
          <Breadcrumbs
            url={window.location.href}
            employerId={this.props.contractor.employerId}
            contractorId={this.props.contractor.id}
            employerName={this.props.currentEmployer.name}
            contractorName={this.props.contractor.forename + ' ' + this.props.contractor.surname}
          />
          <h3>{(this.state.isNew ?
            'Add a new colleague' : this.getHeader()) || 'Edit colleague'}
          </h3>
        </Container>
        <Container soft>
          <Card>
            <div
              className={this.props.errors.Forename ?
                'ln-c-form-group ln-o-grid__item ln-u-1/3 ln-o-generic--div-without-padding has-error ln-o-form-error-message--inline-block' :
                'ln-c-form-group ln-o-grid__item ln-u-1/3 ln-o-generic--div-without-padding'}
            >
              <label htmlFor="txtForename" className="ln-c-label">
                <span>First name </span>
                <span className="ln-c-label__info ln-u-visually-hidden">Required</span>
              </label>
              <input
                id="txtForename"
                type="text"
                placeholder="First name"
                className="ln-c-text-input"
                value={this.state.forename}
                onChange={e => this.handleTextChange(e, 'forename', false, false, true, this.clearErrors('Forename'))}
                maxLength="150"
              />
              <FormFieldValidation errorMessages={this.props.errors.Forename} htmlFor={'txtForename'} />
            </div>
            <div
              className={this.props.errors.Surname ?
                'ln-c-form-group ln-o-grid__item ln-u-1/3 has-error ln-o-form-error-message--inline-block' :
                'ln-c-form-group ln-o-grid__item ln-u-1/3'}
            >
              <label htmlFor="txtSurname" className="ln-c-label">
                <span>Last name </span>
                <span className="ln-c-label__info ln-u-visually-hidden">Required</span>
              </label>
              <input
                id="txtSurname"
                type="text"
                placeholder="Last name"
                className="ln-c-text-input"
                value={this.state.surname}
                onChange={e => this.handleTextChange(e, 'surname', false, false, true, this.clearErrors('Surname'))}
                maxLength="150"
              />
              <FormFieldValidation errorMessages={this.props.errors.Surname} htmlFor={'txtSurname'} />
            </div>
            {this.state.isNew ? '' : <div
              className={'ln-c-form-group ln-o-grid__item ln-u-1/3'}
            >
              <label htmlFor="txtEmail" className="ln-c-label">
                <span>Email address </span>
                <span className="ln-c-label__info ln-u-visually-hidden">Required</span>
              </label>
              <input
                id="txtEmail"
                type="text"
                className="ln-c-text-input"
                value={this.state.email}
                readOnly
                disabled
                maxLength="150"
              />
            </div> }
            <div
              className={this.props.errors.UniqueId ?
                `ln-c-form-group ln-o-grid__item ln-u-1/3 ${this.state.isNew ? '' : 'ln-o-generic--div-without-padding'}
                 has-error ln-o-form-error-message--inline-block` :
                `ln-c-form-group ln-o-grid__item ln-u-1/3 ${this.state.isNew ? '' : 'ln-o-generic--div-without-padding'}`}
            >
              <label htmlFor="txtUniqueId" className="ln-c-label">
                <span>Unique ID </span>
                <span className="ln-c-label__info" aria-hidden="true">(optional)</span>
                <span className="ln-c-label__info ln-u-visually-hidden">Optional</span>
              </label>
              <input
                id="txtUniqueId"
                type="text"
                placeholder="Unique ID"
                className="ln-c-text-input"
                value={this.state.uniqueId}
                onChange={e => this.handleTextChange(e, 'uniqueId', false, false, false, this.clearErrors('UniqueId'))}
                maxLength="50"
              />
              <FormFieldValidation errorMessages={this.props.errors.UniqueId} htmlFor={'txtUniqueId'} />
            </div>
            <div
              className={this.props.errors.JobRoleId ?
                `ln-c-form-group ln-o-grid__item ln-u-1/3 ${this.state.isNew ? 'ln-o-generic--div-without-padding' : ''} 
                has-error ln-o-form-error-message--inline-block` :
                `ln-c-form-group ln-o-grid__item ${this.state.isNew ? 'ln-o-generic--div-without-padding' : ''} ln-u-1/3`}
            >
              <label htmlFor="cboJobRole" className="ln-c-label">
                <span>Job role </span>
                <span className="ln-c-label__info ln-u-visually-hidden">Required</span>
              </label>
              <Dropdown
                items={this.state.dropDownItems}
                selectedItemId={this.state.jobRoleId}
                handleChange={e => this.handleDropdownBoxChange(e, 'jobRoleId', this.clearErrors('JobRoleId'))}
              />
              <FormFieldValidation errorMessages={this.props.errors.JobRoleId} htmlFor={'cboJobRole'} />
            </div>
            <div
              className={this.props.errors.TelephoneNumber ?
                'ln-c-form-group ln-o-grid__item ln-u-1/3 has-error ln-o-form-error-message--inline-block' :
                'ln-c-form-group ln-o-grid__item ln-u-1/3'}
            >
              <label htmlFor="txtTelephoneNumber" className="ln-c-label">
                <span>Telephone number</span>
                <span className="ln-c-label__info ln-u-visually-hidden">Required</span>
              </label>
              <input
                id="txtTelephoneNumber"
                type="text"
                placeholder="Telephone number"
                className="ln-c-text-input"
                value={this.state.telephoneNumber}
                onChange={e => this.handleTextChange(e, 'telephoneNumber', false, false, false,
                  this.clearErrors('TelephoneNumber'))}
                maxLength="20"
              />
              <FormFieldValidation errorMessages={this.props.errors.TelephoneNumber} htmlFor={'txtTelephoneNumber'} />
            </div>
            <div
              className={this.props.errors.CarRegistration ?
                `ln-c-form-group ln-o-grid__item ln-u-1/3 ${this.state.isNew ? '' : 'ln-o-generic--div-without-padding'} 
                has-error ln-o-form-error-message--inline-block` :
                `ln-c-form-group ln-o-grid__item ln-u-1/3 ${this.state.isNew ? '' : 'ln-o-generic--div-without-padding'}`}
            >
              <label htmlFor="txtCarRegistration" className="ln-c-label">
                <span>Car registration </span>
                <span className="ln-c-label__info" aria-hidden="true">(optional)</span>
                <span className="ln-c-label__info ln-u-visually-hidden">Optional</span>
              </label>
              <input
                id="txtCarRegistration"
                type="text"
                placeholder="Car registration"
                className="ln-c-text-input"
                value={this.state.carRegistration}
                onChange={e => this.handleTextChange(e, 'carRegistration', false, true, false, this.clearErrors('CarRegistration'))}
                maxLength="20"
              />
              <FormFieldValidation errorMessages={this.props.errors.CarRegistration} htmlFor={'txtCarRegistration'} />
            </div>
            { this.props.contractor.canDeleteBiometric &&
            <div className="ln-o-grid ln-o-grid--bottom ln-u-push-bottom">
              <div className="ln-o-grid__item ln-u-1/2 ln-u-1/2@xs ln-u-1/3@sm ln-u-1/5@md">
                <OutlinedButton
                  className="ln-c-button ln-c-button--full ln-c-button--secondary"
                  role="button" onClick={e => this.handleDeleteClick(e, true)}
                >Delete biometrics</OutlinedButton>
              </div>
            </div>
            }
            <div
              className={`ln-c-form-group ln-o-grid__item ln-u-1/2 ${this.state.isNew ? 'ln-o-generic--div-without-padding' : ''} ln-o-form-error-message--inline-block`}
            >
              <label htmlFor="txtActiveStatus" className="ln-c-label">
                <span>Active status </span>
              </label><br />
              <ul className="ln-o-bare-list ln-u-push-bottom">
                <li className="ln-o-bare-list__item">
                  <div className="ln-c-form-option ln-c-form-option--checkbox">
                    <input
                      className="ln-c-form-option__input"
                      id="chkActive"
                      type="checkbox"
                      defaultChecked={this.state.active}
                      onChange={e => this.handleCheckboxChange(e, 'active')}
                    />
                    <label className="ln-c-form-option__label" htmlFor="chkActive">Allow this colleague to check in?</label>
                  </div>
                </li>
              </ul>
            </div>
            <div className="ln-o-grid ln-o-grid--bottom">
              <div className="ln-o-grid__item ln-u-1/2 ln-u-1/2@xs ln-u-1/3@sm ln-u-1/5@md">
                <OutlinedButton
                  className="ln-c-button ln-c-button--full ln-c-button--secondary"
                  role="button" onClick={this.handleCancel}
                >Cancel</OutlinedButton>
              </div>
              <div className="ln-o-grid__item ln-u-1/2 ln-u-1/2@xs ln-u-1/3@sm ln-u-1/5@md">
                <FilledButton
                  className="ln-c-button ln-c-button--full ln-c-button--primary"
                  onClick={this.handleSubmit}
                  disabled={(this.state.forename.trim() === '' ||
                             this.state.surname.trim() === '' ||
                             this.state.jobRoleId === 0) ||
                             this.state.telephoneNumber.trim() === '' ||
                            (!this.state.isNew &&
                             !this.isChanged()) ||
                            (this.props.errors.Forename ||
                             this.props.errors.Surname ||
                             this.props.errors.JobRoleId ||
                             this.props.errors.TelephoneNumber ||
                             this.props.errors.UniqueId ||
                             this.props.errors.CarRegistration)}
                >Save</FilledButton>
              </div>
            </div>
          </Card>
        </Container>
        <DeleteModal
          modalAlertOpen={this.state.isDeleteModalOpen}
          options={this.state.options}
          handleOptionsSelectionChange={this.handleDeleteModalReasonChange}
          modalAlertCancel={this.handleDeleteModalCancel}
          modalAlertConfirm={this.handleDeleteModalConfirm}
          modalDoneClick={this.handleDeleteModalDoneClick}
          forename={this.state.forename}
          surname={this.state.surname}
          hasError={this.state.hasDeletionErrored}
          deleteModalText={this.state.deleteModalText}
          deleteReasonText={this.state.deleteReasonText}
          doneConfirmationText={this.state.doneConfirmationText}
          doneInformationText={this.state.doneInformationText}
        />
      </div>
    )
  }
}

ContractorForm.propTypes = {
  contractor: PropTypes.shape({
    id: PropTypes.number.isRequired,
    forename: PropTypes.string,
    surname: PropTypes.string,
    email: PropTypes.string,
    telephoneNumber: PropTypes.string,
    uniqueId: PropTypes.string,
    carRegistration: PropTypes.string,
    employerId: PropTypes.number.isRequired,
    jobRoleId: PropTypes.number,
    active: PropTypes.bool,
    canDeleteBiometric: PropTypes.bool
  }).isRequired,
  errors: PropTypes.shape({
    Forename: PropTypes.arrayOf(PropTypes.string),
    Surname: PropTypes.arrayOf(PropTypes.string),
    JobRoleId: PropTypes.arrayOf(PropTypes.string),
    TelephoneNumber: PropTypes.arrayOf(PropTypes.string),
    UniqueId: PropTypes.arrayOf(PropTypes.string),
    CarRegistration: PropTypes.arrayOf(PropTypes.string),
  }),
  setDirty: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired
}

ContractorForm.defaultProps = {
  errors: null
}

const mapStateToProps = state => ({
  currentEmployer: state.currentEmployer
})

export default connect(mapStateToProps, null)(withRouter(ContractorForm))



// WEBPACK FOOTER //
// ./src/components/Contractor/ContractorForm/index.jsx